import React, { useState } from 'react';
import { useBookingWizard } from 'core/contexts/bookingWizard';
import { ITEM_TYPE } from 'core/contexts/search';
import { EntityService } from 'core/api/services/lookUp';
import { Field, useFormState } from 'react-final-form';
import { Grid2, IconButton, InputAdornment } from '@mui/material';
import { Clear, Search } from '@mui/icons-material';
import { LookUpContract, TextInput } from '@utriper/core-ui';
import ActivityCards from './components/ActivityCards';
import Summary from './components/Summary';
import ActivityForm from '../ActivityForm';
import { Title, Container } from '../../styles';

const SelectActivityForm = ({ form }) => {
    const { handleUpsertCheckoutItem, parseItemToAdd, handleAddBundleItem, setContractId } = useBookingWizard();
    const { values } = useFormState();
    const [openForm, setOpenForm] = useState(false);
    const [itemToAdd, setItemToAdd] = useState(null);
    const [bottomSpace, setBottomSpace] = useState(0);

    const handleOpen = (item) => {
        if (item?.type === ITEM_TYPE.EXPERIENCE) {
            setOpenForm(item);
            setItemToAdd(parseItemToAdd(item));
            return;
        } else if (item?.type === ITEM_TYPE.BUNDLE) {
            handleAddBundleItem(item);
        }
    };

    const handleClose = () => {
        setOpenForm(false);
        setItemToAdd(null);
    };

    const handleAddItem = (newItem) => {
        handleUpsertCheckoutItem(newItem);
        handleClose();
    };

    return (
        <Grid2 size={12} sx={{ height: '100%', display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
            {/* Form */}
            <Grid2 container size={{ xs: 12, md: 6 }} width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" sx={{ pb: { xs: `${bottomSpace}px`, md: 0 }, flex: 1, overflow: 'hidden' }}>
                <Title title="¿Qué deseas reservar?" description="Selecciona las experiencias o paquetes que va a incluir en esta reserva." />

                {/* Contract Lookup */}
                <Container sx={{ '& .MuiAutocomplete-root': { width: '100%' } }}>
                    <Field
                        name="contractId"
                        render={({ input }) => (
                            <LookUpContract
                                {...input}
                                label={'Buscar Contrato...'}
                                entityService={EntityService}
                                value={values?.contractId}
                                initialValue={values?.contractId}
                                onChange={(contractId) => {
                                    form.change('contractId', contractId);
                                    setContractId(contractId);
                                }}
                            />
                        )}
                    />
                </Container>

                {/* Search Input */}
                <Container>
                    <Field
                        name="search"
                        component={TextInput}
                        placeholder={'Buscar experiencias o paquetes...'}
                        label={''}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                                endAdornment:
                                    values?.search?.length > 0 ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    form.change('search', '');
                                                }}
                                            >
                                                <Clear />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                            },
                        }}
                    />
                </Container>

                <ActivityCards handleOpen={handleOpen} />
            </Grid2>
            <Grid2 container size={{ xs: 12, md: 6 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Summary setBottomSpace={setBottomSpace} />
            </Grid2>

            <ActivityForm open={openForm} initialItem={itemToAdd} handleSubmit={handleAddItem} handleClose={handleClose} />
        </Grid2>
    );
};

export default SelectActivityForm;
